import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { GenericUserStream } from '../../../../interfaces/responsedata.ts/generic-streams';
import { Router } from '@angular/router';

@Component({
    selector: 'app-stream-row',
    standalone: false,
    templateUrl: './stream-row.component.html',
    styleUrl: './stream-row.component.scss'
})
export class StreamRowComponent {
    @Input({ required: true }) streamName: string | null = null;
    @Input({ required: true }) stream: GenericUserStream | undefined;
    @Input({ required: true }) categories: string[] = [];
    @Output() deleteStream: EventEmitter<void> = new EventEmitter();

    router = inject(Router);
    showMenue: boolean = false;

    gotoResults(): void {
        this.router.navigate(['/generic-stream', 'result', this.stream?.id], { queryParams: { cid: this.stream?.configId } });

    }
    continue(): void {
        this.router.navigate(['/generic-stream', this.stream?.id], { queryParams: { cid: this.stream?.configId } });
    }
    deleteStreamClicked(): void {
        this.deleteStream.emit();
    }
}

